const GetSupplierNamesReducer = (state = { type: 'LOADING_SUPPLIER_NAMES_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUPPLIER_NAMES_ACTION':
            return action
        default:
            return state
    }
}

const GetSupplierPerfReducer = (state = { type: 'LOADING_COMAN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_COMAN_ACTION':
            return action
        default:
            return state
    }
}

const GetSupplierPerfInhouseReducer = (state = { type: 'LOADING_SPM_INHOUSE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SPM_INHOUSE_ACTION':
            return action
        case 'RESET_SPM_INHOUSE_TYPE':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetSupplierPerfFilterDetailsReducer = (state = { type: 'LOADING_SUPPLIER_PERFORMACE_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUPPLIER_PERFORMACE_FILTER_ACTION':
            return action
        case 'RESET_SUPPLIER_PERFORMACE_FILTER_TYPE':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

const GetSupplierPerfVendorListReducer = (state = { type: 'LOADING_VENDOR_LIST_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_VENDOR_LIST_ACTION':
            return action
        case 'RESET_VENDOR_LIST_FILTER_TYPE':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}
const GetSPMSupplierDetailsReducer = (state = { type: 'LOADING_SPM_SUPPLIERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SPM_SUPPLIERS_ACTION':
            return action
        case 'RESET_SPM_SUPPLIERS_FILTER_TYPE':
            return {
                ...state,
                type: action.payload
            };
        default:
            return state
    }
}

export {
    GetSupplierPerfReducer,
    GetSupplierNamesReducer,
    GetSupplierPerfFilterDetailsReducer,
    GetSupplierPerfInhouseReducer,
    GetSupplierPerfVendorListReducer,
    GetSPMSupplierDetailsReducer
}